import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, map, take, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Tipo } from "../models/tipo.model";

@Injectable({
  providedIn: "root",
})
export class TiposService {
  private tipos$ = new BehaviorSubject<Tipo[]>(null);
  constructor(private http: HttpClient) {}

  public getAll(): Observable<Tipo[]> {
    return this.http.get<Tipo[]>(environment.rotaTipos).pipe(
      map((tipo) => tipo.map((tipo) => new Tipo().deserialize(tipo))),
      catchError(() => throwError("tipo não encontrado."))
    );
  }

  public getAll$() {
    this.http
      .get<Tipo[]>(environment.rotaTipos)
      .pipe(
        take(1),
        tap((tipos) => {
          this.tipos$.next(tipos);
        }),
        catchError((error) => {
          // this.isLoading$.next(false);
          console.log('error: ', error);
          
          return throwError(() => new Error('Erro ao filtrar tipos: '));
        })
      )
      .subscribe();
  }

  public escutarMudancasTipo(): Observable<Tipo[]> {
    return this.tipos$.asObservable();
  }

  public atualizarTipos(tipos: Tipo[]) {
    return this.tipos$.next(tipos);
  }

  public adicionarTipo(tipo: Tipo) {
    const tiposAtuais = this.tipos$.value;
    this.tipos$.next([tipo, ...tiposAtuais]);
  }

  private updateTipoInState(updatedTipo: Tipo) {
    this.tipos$.pipe(take(1)).subscribe((tipos) => {
      // Substitui a guia atualizada na lista do BehaviorSubject
      const updatedTipos = tipos.map((tipo) =>
        tipo._id === updatedTipo._id ? updatedTipo : tipo
      );
      // Atualiza o BehaviorSubject com a nova lista
      this.tipos$.next(updatedTipos);
    });
  }

  public edit(updatedTipo: Tipo) {
    return this.http
      .patch(`${environment.rotaTipos}/${updatedTipo._id}`, updatedTipo)
      .pipe(
        map(() => {
          // Atualiza a lista localmente após sucesso na atualização do servidor
          this.updateTipoInState(updatedTipo);
        }),
        catchError((error) =>
          throwError("Erro ao atualizar categoria: " + error)
        )
      );
  }

  public create(tipo: Tipo) {
    return this.http.post(environment.rotaTipos, tipo).pipe(
      map((novoTipo: Tipo) => {
        // Atualiza a lista localmente após sucesso na atualização do servidor
        this.adicionarTipo(novoTipo);
      }),
      catchError((error) => throwError("Erro ao criar categoria: " + error))
    );
  }

  public delete(tipo: Tipo): Observable<any> {
    return this.http.delete(`${environment.rotaTipos}/${tipo._id}`);
  }
}
